module.exports = __webpack_public_path__ + "static/img/2.d2bc34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/2.png
// module id = qea8
// module chunks = 0